<div class="full-page-container">
  <!--Point Summary Bar-->
  <div class="container">
    <fgb-points-summary-bar [backButtonTitle]="'Rewards'"></fgb-points-summary-bar>
  </div>
  <!--Lotto Details-->
  <div class="container">
    <div
      class="back-btn text-primary cursor-pointer d-none d-lg-flex align-items-center justify-content-center"
      [routerLink]="'/rewards/raffles'"
    >
      <span class="material-symbols-outlined ms-2 text-white"> arrow_back_ios </span>
    </div>
  </div>

  <fgbcl-lotto-details [lottoId]="id" [showTermsAndConditions]="true"></fgbcl-lotto-details>
</div>
